import { useSelector } from "react-redux";
import { EditIcon, ReminderTimeIcon } from "@fluentui/react-icons-mdl2";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { useTheme } from "@fluentui/react/lib/Theme";

import { DataSourceIcon } from "Components/Generic/DataSourceIcon";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { selectActiveProject } from "Store/Selectors/Projects";
import { OptionalLink } from "Components/Generic/OptionalLink";
import { FooterElement } from "./FooterElement";
import { useFooterStyles } from "./UseFooterStyles";

export const Footer = WithTranslator((props: IWithTranslatorProps): JSX.Element => {
  const { translator } = props;
  const project = useSelector(selectActiveProject);
  const { spacing } = useTheme();
  const { iconStyles } = useFooterStyles();
  const { dataSource, dataSourceId, dataSourceUrl } = project;

  return (
    <>
      <Stack.Item>
        <OptionalLink
          as="a"
          href={dataSourceUrl}
          target="_blank"
          alt={`Link to project at ${translator.get(`provider.${dataSource}`, dataSource)}`}
        >
          <DataSourceIcon styleSet={iconStyles} dataSource={project.dataSource} />
        </OptionalLink>
      </Stack.Item>
      <Stack.Item>
        <Text variant="smallPlus">
          <OptionalLink
            as="a"
            href={dataSourceUrl}
            target="_blank"
            alt={`Link to project at ${translator.get(`provider.${dataSource}`, dataSource)}`}
          >
            {translator.get(`provider.${dataSource}`, dataSource)}
          </OptionalLink>
        </Text>
      </Stack.Item>
      <Stack.Item>
        <Text variant="smallPlus">
          <OptionalLink
            as="a"
            href={dataSourceUrl}
            target="_blank"
            alt={`Link to project at ${translator.get(`provider.${dataSource}`, dataSource)}`}
          >
            {dataSourceId}
          </OptionalLink>
        </Text>
      </Stack.Item>
      <Stack.Item grow>&nbsp;</Stack.Item>
      <Stack horizontal tokens={{ childrenGap: spacing.s2 }}>
        <Stack.Item>
          <EditIcon />
        </Stack.Item>
        <Stack.Item>
          <FooterElement fieldName="@modifiedOn" project={project} />
        </Stack.Item>
      </Stack>
      <Stack horizontal tokens={{ childrenGap: spacing.s2 }}>
        <Stack.Item>
          <ReminderTimeIcon />
        </Stack.Item>
        <Stack.Item>
          <FooterElement fieldName="@createdOn" project={project} />
        </Stack.Item>
      </Stack>
    </>
  );
});
